<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Exportação de dados OS</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <mat-card class="card-style py-4 px-6 mt-6 mb-4">
    <div class="flex justify-between gap-4 items-center my-3">
      <div class="w-4/12"><strong>Cod. OS: </strong> {{ item.codigoOs }}</div>
      <div class="w-4/12"><strong>Evento: </strong> {{ item.nomeEvento }}</div>
      <div class="w-4/12">
        <strong>Período: </strong> {{ item.dataInicio }} - {{ item.dataFinal }}
      </div>
    </div>
    <mat-divider style="border-color: #cecece"></mat-divider>
    <div class="flex justify-between gap-4 items-center my-3">
      <div class="w-4/12">
        <strong>Cliente: </strong> {{ item.nomeCliente }}<br />
        @if (item.nomeSubCliente) {
          <strong>Subcliente: </strong> {{ item.nomeSubCliente }}<br />
        }
      </div>
      <div class="w-4/12">
        <strong>Consultor Operacional: </strong> {{ item.consultorOperacional }}
      </div>
      <div class="w-4/12">
        <strong>Hora: </strong> {{ formatHour(item.horaInicio) }} -
        {{ formatHour(item.horaFinal) }}
      </div>
    </div>
    <mat-divider style="border-color: #cecece"></mat-divider>
    <div class="flex justify-between gap-4 items-center mt-3">
      <div class="w-3/12">
        <strong>Tipo serviço: </strong> {{ item.tipoServico }}
      </div>
      <div class="w-3/12"><strong>Serviço: </strong> {{ item.servico }}</div>
      <div class="w-3/12">
        <strong>Tipo Veiculo: </strong> {{ item.nomeTipoVeiculo }}
      </div>
      <div class="w-3/12">
        <strong>Tipo Motorista: </strong> {{ item.nomeTipoMotorista }}
      </div>
    </div>
  </mat-card>

  <!--  {{ itemsList | json }}-->
  <mat-stepper headerPosition="top" #stepper>
    <mat-step label="Ordens de serviço">
      <div class="mt-4 container mx-auto">
        @if (!loading) {
          <div class="os_overflow">
            <table-list-select
              [dataSource]="itemsList"
              [columns]="columns"
              [multiSelect]="true"
              [selected]="selected"
              [keyValidator]="'codigoOs'"
              [listSelected]="listSelected"
              (selectItem)="selectItem($event)"
            />
          </div>
        } @else {
          <div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
        @if (itemsList.length > 0) {
          <mat-paginator
            [length]="numberRows"
            [pageSize]="rows"
            [pageIndex]="page - 1"
            [pageSizeOptions]="[5, 10, 20, 30]"
            (page)="onPageEvent($event)"
          >
          </mat-paginator>
        }
      </div>
    </mat-step>
    <mat-step label="Itens replicados">
      <div [formGroup]="form" class="mt-4 container mx-auto">
        <div class="flex justify-between items-center mt-3 -mx-2">
          <mat-slide-toggle
            class="input-tg w-2/12 px-2"
            formControlName="observation"
            >Observação:
            <strong>{{
              form.get('observation')?.value ? 'sim' : 'não'
            }}</strong></mat-slide-toggle
          >
          <mat-slide-toggle
            class="input-tg w-2/12 px-2"
            formControlName="passage"
            >Passageiros:
            <strong>{{
              form.get('passage')?.value ? 'sim' : 'não'
            }}</strong></mat-slide-toggle
          >
          <mat-slide-toggle
            class="input-tg w-2/12 px-2"
            formControlName="itineraries"
            >Itinerários:
            <strong>{{
              form.get('itineraries')?.value ? 'sim' : 'não'
            }}</strong></mat-slide-toggle
          >
          <mat-slide-toggle
            class="input-tg w-2/12 px-2"
            formControlName="time"
            (change)="changeValue($event)"
            >Horários:
            <strong>{{
              form.get('time')?.value ? 'sim' : 'não'
            }}</strong></mat-slide-toggle
          >
          <mat-form-field
            class="input-tg w-2/12 px-2 no-message-new"
            appearance="outline"
          >
            <mat-label>Hora Início (24h)</mat-label>
            <input matInput type="time" formControlName="hourStart" />
          </mat-form-field>
          <mat-form-field
            class="input-tg w-2/12 px-2 no-message-new"
            appearance="outline"
          >
            <mat-label>Hora Final (24h)</mat-label>
            <input matInput type="time" formControlName="hourEnd" />
          </mat-form-field>
        </div>
        <div class="flex justify-end items-center mt-3 -mx-2">
          <button
            mat-flat-button
            class="btn-tg w-1/5"
            [disabled]="!validForm() || loadingBtn"
            (click)="importItem()"
          >
            @if (loadingBtn) {
              <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
            } @else {
              Importar dados
            }
          </button>
        </div>
      </div>
    </mat-step>
  </mat-stepper>

  <!--  <div [formGroup]="form" class="flex justify-between gap-4 items-center mt-3">-->
  <!--    <mat-form-field-->
  <!--      class="input-tg mt-message-input w-2/4"-->
  <!--      appearance="outline"-->
  <!--    >-->
  <!--      <mat-label>Código</mat-label>-->
  <!--      <input matInput formControlName="code" />-->
  <!--    </mat-form-field>-->
  <!--    <mat-form-field-->
  <!--      class="input-tg mt-message-input w-2/4"-->
  <!--      appearance="outline"-->
  <!--    >-->
  <!--      <mat-label>Descrição</mat-label>-->
  <!--      <input matInput formControlName="description" />-->
  <!--    </mat-form-field>-->
  <!--  </div>-->

  <!--  <div class="flex justify-end">-->
  <!--    <button-->
  <!--      mat-flat-button-->
  <!--      class="btn-tg w-1/5"-->
  <!--      [disabled]="form.invalid || loading"-->
  <!--      (click)="updateItem()"-->
  <!--    >-->
  <!--      @if (loading) {-->
  <!--        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>-->
  <!--      } @else {-->
  <!--        Salvar-->
  <!--      }-->
  <!--    </button>-->
  <!--  </div>-->
</mat-card>
